import styled from 'styled-components'
import Fonts, { weight, family } from 'components/base-ui/Fonts'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
`

const Title = styled(Fonts.H2)`
  font-weight: ${weight.normal};
`

const Description = styled(Fonts.Base)`
  font-size: 16px;
  font-family: ${family.brand};
  color: ${({ theme }) => theme.colors.darkGrey};
`

const PointRequired = styled(Description)`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.primary};
`

const Period = styled(Description)`
  font-size: 18px;
`

const BackWrapper = styled.div`
  position: fixed;
  display: flex;
  z-index: 99;
  justify-content: space-between;
  top: 20px;
  left: 20px;
`

const ConfirmInfo = styled(Description)`
  font-size: 14px;
`

const Point = styled(ConfirmInfo)`
  white-space: nowrap;
`

const RedeemInfo = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  column-gap: 20px;
  border-top: 1px solid ${({ theme }) => theme.colors.baseGrey};
  border-bottom: 1px solid ${({ theme }) => theme.colors.baseGrey};
`

const RedeemButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export {
  Wrapper,
  Image,
  Title,
  Description,
  PointRequired,
  Period,
  BackWrapper,
  ConfirmInfo,
  RedeemInfo,
  RedeemButtonWrapper,
  Point,
}
